import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform, TextInput } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, aboutAuthor, pageContent, input, Colors, bannerStyles, Messages, FontFamily, FontWeight ,button} from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import TouchableOpacityLinkExternal from '../touchable-opacity-link-external';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import { helpers } from '../../utils/helpers';
import Button from '../button';
import ButtonGradient from '../button-gradient';

// const banner = getImagePath('img/banner-slide.png');
const bannerDark = getImagePath('img/banner-slide-dark.png');
const circleLeft = getImagePath('img/banner-left-circle.png');
const circleRight = getImagePath('img/banner-right-circle.png');
const circleRightDark = getImagePath('img/banner-right-circle-dark.png');

export class HomeBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnDisable: true,
            email: '',
            referralMsg: {
                enable: false,
                type: '', // error / success
                msg: ''
            },
        }
    }

    componentDidMount = () => {

    }

    signUp = () => {
        const { email } = this.state;
        this.setState({
            btnLoader: true,
            referralMsg: {
                enable: false,
                type: '',
                msg: ''
            }
        });

        // if (helpers.validateEmail(email)) {
        //     this.setState({
        //         btnLoader: false
        //     });
        //     try {
        //         if (this.props.trackSignUp) {
        //             this.props.trackSignUp(email, 'top banner');
        //         }
        //     }
        //     catch (error) {
        //         console.log("mix panel track error ==>", error);
        //     }
            if (helpers.isWeb()) {
                this.props.navigateWeb(`/sign-up?redirect=/&email=${email}`)
            } else {
                this.props.navigateApp('/sign-up', { redirect: '/', verifyRedirect: '/', email: email });
            }
        // }
        // else {
        //     this.setState({
        //         btnLoader: false,
        //         referralMsg: {
        //             enable: true,
        //             type: 'error',
        //             msg: 'Please enter a valid email'
        //         }
        //     });
        // }
    }

    validateInput = (value) => {
        if (value) {
            this.setState({ btnDisable: false, email: value });
        } else {
            this.setState({ email: value, btnDisable: true })
        }
    }


    render() {
        let { email, btnDisable, referralMsg } = this.state;
        let webView = helpers.isWeb();
        let { darkMode, textColor } = this.props;

        const banner = helpers.isDesktop()? require("../../../../assets/img/banner-slide.png") : require("../../../../assets/img/Mobilebanner.png") 
        let signInProps;
        if (webView) {
            signInProps = {
                to: '/sign-in?redirect=/'
            }
        } else {
            signInProps = {
                onPress: () => this.props.navigateApp('/sign-in', { redirect: '/', verifyRedirect: '/' })
            }
        }

        return (
            <View>
                <CustomImage
                    source={darkMode ? bannerDark : banner}
                    require={true}
                    style={{ width: '100%', height: helpers.isDesktop() ? 550 : 400 }}
                    webStyle={{ width: '100%', height: helpers.isDesktop() ? '100%' : 400 , paddingTop: helpers.isDesktop ? 0 : 0,marginTop:helpers.isDesktop ? -20 : 0 }}
                    altText={'The Morning Context'}
                />
                <View style={[{ position: 'absolute', top: helpers.isDesktop() ? '20%' : '35%', left: helpers.isDesktop() ? '14%' : 0, zIndex: 2 }, { maxWidth: helpers.isDesktop() ? 1274 : '100%' }, !helpers.isDesktop() && { width: '100%', paddingHorizontal: 18 ,alignItems:'center'}]}>
                    <Text style={[bannerStyles.heading, { fontSize: helpers.isDesktop() ? 70 : 30, marginBottom: 10 }, helpers.isWeb() && { fontWeight: FontWeight.bold}, !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>Context is everything.</Text>
                    <Text accessibilityRole="header" aria-level="1" style={[bannerStyles.heading, { fontSize: helpers.isDesktop() ? 45 : 20, marginBottom: 10 }, helpers.isWeb() && { fontWeight: FontWeight.bold}, !helpers.isWeb() && {fontFamily: FontFamily.semiBold},!helpers.isDesktop() && {marginLeft:-27}]}>Only read stories that matter.</Text>

                    <Text accessibilityRole="header" aria-level="1" style={[bannerStyles.heading, { fontSize: helpers.isDesktop() ? 30 : 16, marginTop: 30, top:5 }, helpers.isDesktop() && { fontWeight: FontWeight.regular}, !helpers.isDesktop() && {fontFamily: FontFamily.regular},!helpers.isDesktop() && {marginLeft:-27}]}>Join Now and Start Reading for FREE.</Text>

                    <View style={[helpers.isDesktop() && Flex.row, Margin.mt_2,!helpers.isDesktop() && {width:'70%'},{alignSelf:helpers.isDesktop()  ?'flex-start' : 'center'}]}>
                        {/* <TextInput
                            placeholder={'Enter your email address'}
                            placeholderTextColor={Colors.placeholderTextColor}
                            style={[input.Text, input.borderBottom, Padding.pt_1, Padding.pl_15, !helpers.isDesktop() && Padding.pl_1, Padding.pb_1, !helpers.isDesktop() && Margin.mb_1, helpers.isDesktop() && { marginBottom: 6, height: 50, fontSize: 16 }, { backgroundColor: 'white', width: helpers.isDesktop() ? '60%' : '100%' }, !helpers.isDesktop() && { fontSize: 13, height: 42 }, (referralMsg.enable) && { borderWidth: 2, borderBottomWidth: 2, borderColor: darkMode ? '#F4A886' : '#FF525E' }]}
                            onChangeText={this.validateInput}
                            value={email}
                        /> */}
                        {/* <TouchableOpacityLink style={{ backgroundColor: '#3B58A7', paddingLeft: helpers.isDesktop() ? 20 : 10, paddingRight: helpers.isDesktop() ? 20 : 10, paddingTop: 12, paddingBottom: 10, height: 20 }} disable={btnDisable} {...startFreeTrialProps}>
                            <Text style={[bannerStyles.text, Helpers.textUppercase, { fontWeight: '600', letterSpacing: 0.3, fontSize: helpers.isDesktop() ? 16 : 12 }]}>Start Free Trial</Text>
                        </TouchableOpacityLink> */}
                        <ButtonGradient
                            title={'GET STARTED'}
                            rootStyle={{
                                // btnWrapper: [{ paddingLeft: helpers.isDesktop() ? 20 : 10, paddingRight: helpers.isDesktop() ? 20 : 10, paddingTop: helpers.isDesktop() ? 20 : 12, paddingBottom: 10, height: helpers.isDesktop() ? 60 : 42 }, darkMode && { backgroundColor: Colors.brandColor1 }, { marginLeft: helpers.isDesktop() ? 0 : 0 }],
                                // btnText: [bannerStyles.text, Helpers.textUppercase, { fontWeight: '600', letterSpacing: 0.3, fontSize: helpers.isDesktop() ? 18 : 16, textAlign: helpers.isDesktop() ? 'left' : 'center', paddingLeft: helpers.isDesktop() ? 25 : 0, paddingRight: helpers.isDesktop() ? 25 : 0, color: 'white' }]
                                btnWrapper:[button.primaryGradient,{height:helpers.isDesktop() ? 50 :42}],
                                btnText: [button.primaryGradientText, { fontSize: helpers.isDesktop() ? 20 : 16, fontWeight: '500',textAlign: 'center',paddingLeft:50,paddingRight:50,paddingTop:10,paddingBottom:10 }]
                            }}
                            onClick={this.signUp}
                            // disable={btnDisable}
                            textWhite={true}
                        />
                    </View>
                    {referralMsg.enable &&
                        <View style={[{ marginTop: 5 }]}>
                            <Text style={[referralMsg.type == 'success' ? Messages.successText : Messages.errorText, { color: darkMode ? '#F4A886' : '#FF525E' }]}>{referralMsg.msg}</Text>
                        </View>
                    }
                    {/* <View style={[Margin.mt_1, Margin.mb_1, { flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'baseline' }]}>
                        <Text style={[bannerStyles.text, { fontSize: helpers.isDesktop() ? 18 : 14 }]}>Already have an account? </Text><TouchableOpacityLink {...signInProps}><Text style={[bannerStyles.text, { fontSize: helpers.isDesktop() ? 18 : 14, fontWeight: '700', color: 'white', textDecorationLine: 'underline' }]}>Sign in.</Text></TouchableOpacityLink>
                    </View> */}
                </View>
               
                {/* <CustomImage
                    source={circleLeft}
                    require={true}
                    style={{ width: helpers.isDesktop() ? 150 : 70, height: helpers.isDesktop() ? 190 : 80, position: 'absolute', left: 0, bottom: 0 }}
                    webStyle={{ width: helpers.isDesktop() ? 150 : 70, height: helpers.isDesktop() ? 190 : 80, position: 'absolute', left: 0, bottom: 0 }}
                    altText={'The Morning Context'}
                />
                <CustomImage
                    source={darkMode ? circleRightDark : circleRight}
                    require={true}
                    style={{ width: helpers.isDesktop() ? 150 : 75, height: helpers.isDesktop() ? 240 : 130, position: 'absolute', right: 0, top: '25%' }}
                    webStyle={{ width: helpers.isDesktop() ? 150 : 75, height: helpers.isDesktop() ? 240 : 130, position: 'absolute', right: 0, top: '25%' }}
                    altText={'The Morning Context'}
                /> */}
            </View >
        );
    }
}

export default HomeBanner;